const fromSeconds = (time) => {
    return time * 1000;
};

const fromMinutes = (time) => {
    return fromSeconds(time) * 60;
};

const fromHours = (time) => {
    return fromMinutes(time) * 60;
};

const toSeconds = (time) => {
    return time / 1000;
};

const stringToSeconds = (timeString, fps = 60) => {
    if (!timeString) return;
    const timeArr = timeString.split(':').map((v) => ~~v);
    const value = timeArr[1] * 60 + timeArr[2] + timeArr[3] / fps;
    return value;
};

const toMinutes = (time) => {
    return toSeconds(time) / 60;
};

const toHours = (time) => {
    return toMinutes(time) / 60;
};

/**
 *
 * @param {Number} time in ms
 * @returns object object contains hours, minutes, seconds
 */
const convertTime = (time) => {
    const t = Math.max(0, time);

    const seconds = Math.floor((t / 1000) % 60)
        .toString()
        .padStart(2, '0');
    const minutes = Math.floor((t / 1000 / 60) % 60)
        .toString()
        .padStart(2, '0');
    const hours = Math.floor((t / 1000 / 60 / 60) % 24)
        .toString()
        .padStart(2, '0');
    const days = Math.floor(t / 1000 / 60 / 60 / 24)
        .toString()
        .padStart(2, '0');

    return { days, hours, minutes, seconds };
};

export { fromSeconds, fromMinutes, fromHours, toSeconds, stringToSeconds, toMinutes, toHours, convertTime };
